module.exports = __webpack_public_path__ + "static/ConfidentialPro-431108a552d3859c68b25a35a4195f52.woff";